import { WIX_ECOM, WIX_NEW_STORES } from '@wix/app-definition-ids';

export function getStoresAppDefId() {
  return WIX_NEW_STORES;
}

export function getEcomAppDefId() {
  return WIX_ECOM;
}
